module.exports = __webpack_public_path__ + "static/avatar_xxt-7b7fa8ffdea452ff720aa6207a4e4693.png";